import {Component, Input, OnInit} from '@angular/core';
import {EnumStatusContato, NOME_DO_SEGMENTO} from "../../../../server/lib/emun/EnumStatusContato";

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'contato-status',
  templateUrl: './contato-status.component.html',
  styleUrls: ['./contato-status.component.scss']
})
export class ContatoStatusComponent implements OnInit {
  @Input() contato: any;

  readonly classePorSegmento: {[status: string]: string} = {
    [EnumStatusContato.Campeao]: 'campeao',
    [EnumStatusContato.Fiel]: 'fiel',
    [EnumStatusContato.Novo]: 'novo',
    [EnumStatusContato.Esfriando]: 'esfriando',
    [EnumStatusContato.Sumido]: 'sumido',
    [EnumStatusContato.Perdido]: 'perdido',
    [EnumStatusContato.SemPedido]: 'sem-pedido'
  };

  constructor() { }

  ngOnInit() {
  }

  nome(): string {
    return this.contato ? (NOME_DO_SEGMENTO as any)[this.contato.status] || '' : '';
  }

  classe(): string {
    return this.contato ? this.classePorSegmento[this.contato.status] || '' : '';
  }
}
